import { render, staticRenderFns } from "./TakePayMechanic.vue?vue&type=template&id=54fc5383&scoped=true"
import script from "./TakePayMechanic.vue?vue&type=script&lang=js"
export * from "./TakePayMechanic.vue?vue&type=script&lang=js"
import style0 from "./TakePayMechanic.vue?vue&type=style&index=0&id=54fc5383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fc5383",
  null
  
)

export default component.exports